// extracted by mini-css-extract-plugin
export default {"idleStatus":"IdleStatus_idleStatus__mD6Gj"};